import { render } from "./ChecklistEditor.vue?vue&type=template&id=978a5106&scoped=true"
import script from "./ChecklistEditor.vue?vue&type=script&lang=js"
export * from "./ChecklistEditor.vue?vue&type=script&lang=js"

import "./ChecklistEditor.vue?vue&type=style&index=0&id=978a5106&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-978a5106"]])

export default __exports__